module.exports = __webpack_public_path__ + "static/media/order-calendar-left-arrow.383cdc49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/order-calendar-left-arrow.svg
// module id = 376
// module chunks = 0